import type { FC } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useActiveDialogCleaner } from '../../../../store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { HeaderModal } from '../../../../store/slices/header/types';

import { HelpControlPlain } from './HelpControlPlain';

export const HelpControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const hideUI = useGameStateSlice.hideUI();
  const cleanDialogs = useActiveDialogCleaner();

  return (
    <HelpControlPlain
      condition={openedModal === HeaderModal.Help && !hideUI}
      onClick={(): void => {
        // UIC-64 | Hide Dialogs Functionality
        if (hideUI) {
          cleanDialogs();
        }
        if (!hideUI && openedModal === HeaderModal.Help) {
          dispatch(headerActions.setOpenedModal(null));
        } else {
          Logger.logEvent('openHelp');
          dispatch(headerActions.setOpenedModal(HeaderModal.Help));
        }
      }}
    />
  );
};
